<template>
  <section>
    <div class="role">
      <div class="roleRight" style="overflow-x: hidden">
        <div class="roleRight_Top public-table-data" style="margin-bottom:20px;display: block">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                style="margin-bottom: 10px;margin-right: 10px"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-select
                v-model="search.status"
                clearable
                filterable
                placeholder="回调状态"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in CallbackStatus"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.bizType"
                clearable
                filterable
                placeholder="业务类型"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in BusinessType"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.eventCode"
                clearable
                filterable
                style="margin-bottom: 10px;margin-right: 10px"
                placeholder="事件标识">
              <el-option
                  v-for="item in EventIdentification"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.channelAccountId"
                clearable
                filterable
                placeholder="渠道账号">
              <el-option
                  v-for="item in channelList"
                  :key="item.channelAccountId"
                  :label="item.name+'('+item.account+')'"
                  :value="item.channelAccountId"
              ></el-option>
            </el-select>
            <div></div>
            <div class="block timeblock" style="width: 410px;margin-bottom: 10px">
              <el-date-picker
                  v-model="value2"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format='yyyy-MM-dd HH:mm:ss'
              >
              </el-date-picker>
            </div>
            <el-button size="medium" type="primary" @click="getserviceList(1)"
            >查询
            </el-button
            >
          </template>

          <el-button v-if="downShow" size="medium" type="primary" @click="upserviceList"
          >下载
          </el-button
          >
        </div>
        <div class="public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="customerServiceId"
              v-loading="loading"
          >
            <el-table-column fixed label="业务ID" type="index" width="100">
              <template slot-scope="scope">
                <el-popover
                    placement="top-start"
                    title=""
                    width="200"
                    trigger="hover"
                    :content="scope.row.bizId">
                  <div slot="reference" style="overflow:  hidden;text-overflow: ellipsis;white-space: nowrap">
                    {{ scope.row.bizId }}
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="logid" label="线索ID" min-width="150">
              <template slot-scope="scope">
                <el-popover
                    placement="top-start"
                    title=""
                    width="200"
                    trigger="hover"
                    :content="scope.row.logid">
                  <div slot="reference" style="overflow:  hidden;text-overflow: ellipsis;white-space: nowrap">
                    {{ scope.row.logid }}
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="ip" label="IP" min-width="130"></el-table-column>
            <el-table-column prop="channelTypeName" label="渠道类型" min-width="50"></el-table-column>
            <el-table-column prop="channelAccount" label="渠道账户" min-width="180"></el-table-column>
            <el-table-column prop="channelName" label="渠道名称" min-width="100"></el-table-column>
            <el-table-column prop="bizTypeName" label="业务类型" min-width="80"></el-table-column>
            <el-table-column prop="eventName" label="事件名称" min-width="80"></el-table-column>
            <el-table-column prop="eventCode" label="事件代码" min-width="120"></el-table-column>
            <el-table-column prop="callbackTime" label="回传时间" min-width="180"></el-table-column>
            <el-table-column prop="logurl" label="落地页" min-width="200">
              <template slot-scope="scope">
                <el-popover
                    placement="top-start"
                    title=""
                    width="200"
                    trigger="hover"
                    :content="scope.row.logurl">
                  <div slot="reference" style="overflow:  hidden;text-overflow: ellipsis;white-space: nowrap">
                    {{ scope.row.logurl }}
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="paymentType" label="回传状态">
              <template slot-scope="scope">
                {{ scope.row.status == 0 ? '失败' : scope.row.status == 1 ? '成功' : '不回调' }}
              </template>
            </el-table-column>
            <el-table-column prop="msg" label="错误信息" min-width="200"></el-table-column>
            <!--            <el-table-column fixed="right" label="操作" width="100">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-button-->
            <!--                    @click="getOrderDetail('change', scope.row)"-->
            <!--                    type="text"-->
            <!--                    size="small"-->
            <!--                >详情-->
            <!--                </el-button-->
            <!--                >-->
            <!--              </template>-->
            <!--            </el-table-column>-->
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {NEWUSER_ORDER, PAGE_SIZE, PAY_STATUS_1, PAYMENT_TYPE, TIME_TYPE_1} from "@/config";

export default {
  data() {
    return {
      PAGE_SIZE, PAY_STATUS_1, PAYMENT_TYPE, NEWUSER_ORDER, TIME_TYPE_1,
      BusinessType: [
        {
          key: 'exam',
          name: '测评'
        },
        {
          key: 'znqm',
          name: '智能取名'
        },
        {
          key: 'zncm',
          name: '智能测名'
        },
        {
          key: 'gsqm',
          name: '公司取名'
        },
        {
          key: 'taluo',
          name: '塔罗'
        },
      ],
      EventIdentification: [
        {
          key: 'START_EXAM',
          name: '点击开始'
        },
        {
          key: 'SUB_EXAM',
          name: '提交订单'
        },
        {
          key: 'PAY_EXAM',
          name: '支付订单'
        }
      ],
      CallbackStatus: [
        {
          key: '0',
          name: '失败'
        },
        {
          key: '1',
          name: '成功'
        },
        {
          key: '2',
          name: '不回传'
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "", //以上时间选择器
      touFangList: [], //渠道用户投放方式
      enumCode: "PUT_WAY",
      shopList: [], //渠道用户投放方式
      categoryList: [],//测评题分类数组
      dictDataSelect: '',//测评题tree点击后显示
      treeProps: {
        //测评题 配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        // value: "parentId",
        children: "examCategoryVos",
        label: "name",
      },
      channelList: [],//渠道类型list
      appList: [],//归属应用appid
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      tableData: [], //顶顶那列表
      onTime: "",
      offTime: "", //客服开始和结束时间
      loading: false,
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写客服名称"}],
        account: [{required: true, message: "请填写账号"}],
        offTime: [{required: true, message: "请填写结束时间"}],
        onTime: [{required: true, message: "请填写开始时间"}],
      }, //表单验证提示
      searchShow: false,
      downShow: false,
    };
  },
  created() {
    this.getChannelList();
    this.getserviceList();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'order:callback:query') {
            this.searchShow = true
          }
          if (item.code == 'order:callback:down') {
            this.downShow = true
          }
        })
      }
    },
    // 下载事件
    async upserviceList() {
      if (this.value2 && this.value2.length) {
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      } else {
        this.$message.warning("请选择起止时间");
        return;
      }


      let obj = this.search
      let startTime = obj.startTime ? obj.startTime : ''
      let endTime = obj.endTime ? obj.endTime : ''
      if (startTime && endTime) {
        const {data: res} = await this.$get(
            `/channel/callback/export/create`,
            {params: {...this.search}},
            {
              headers: {
                // isLoading: true,
              },
            }
        );
        this.$message.success(res.data)
      } else {
        this.$message.warning('请选择时间')
      }
    },
    // 获取渠道用户投放方式
    async gettouFangList() {
      const {data: orgData} = await this.$get(`/enums/list/${this.enumCode}`);
      this.touFangList = orgData.data;
    },
    //获取归属应用
    async getAppList() {
      const {data: orgData} = await this.$get(`/app/list`);
      this.appList = orgData.data;
    },
    //获取渠道账号
    async getChannelList() {
      const {data: orgData} = await this.$get(`/channel/account/list?paging=false`);
      this.channelList = orgData.data;
    },
    // 获取渠道 商户
    async getshopList() {
      const {data: orgData} = await this.$get(`/channel/mch/list`);
      this.shopList = orgData.data;
    },
    //get categoryList:[],//测评题分类数组
    async getCategoryList() {
      const {data: res} = await this.$get(
          `/exam/category/list?tree=true`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.categoryList = res.data
    },
    //订单列表
    async getserviceList(e) {
      if (e == 1) {
        this.page.pageNo = 1;
      }
      if (this.value2 && this.value2.length) {
        this.search.startTime = this.value2[0]
        this.search.endTime = this.value2[1]
      }
      this.loading = true;
      const {data: res} = await this.$get(
          `/channel/callback/list`,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      this.tableData = res.data;
      this.page.count = res.page.count;
    },
    //订单详情
    // async getOrderDetail(mthold, row) {
    //   const { data: orgData } = await this.$get(`/exam/order/info`);
    //   this.shopList = orgData.data;
    // },


    //tree 点击  categoryId:测评题分类id
    handleNodeClick: function (node) {
      this.dictDataSelect = node.name;
      this.search.categoryId = node.categoryId
      this.$refs.selectReport.blur();
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

</style>

<style scoped>
</style>